import { useState } from 'react';
import { shareQrcodeImg } from '../utils';

const ShareButton = () => {
  const [showQrCode, setShowQrCode] = useState(false); // hover 小弹窗
  const [showFullScreen, setShowFullScreen] = useState(false); // 全屏遮罩
  const [hoverDisabled, setHoverDisabled] = useState(false); // 防止点击触发 hover

  const handleClick = () => {
    setHoverDisabled(true); // 禁用 hover
    setShowQrCode(false); // 关闭小弹窗
    setShowFullScreen(true); // 打开遮罩层
  };

  const handleCloseFullScreen = () => {
    setShowFullScreen(false);
    // 延迟恢复 hover 防止点击后立即触发
    setTimeout(() => setHoverDisabled(false), 300);
  };

  return (
    <div
      className="absolute top-[16px] right-[20px] z-10"
      onMouseEnter={() => !hoverDisabled && setShowQrCode(true)}
      onMouseLeave={() => !hoverDisabled && setShowQrCode(false)}
    >
      {/* 分享按钮 */}
      <button
        className="text-gray-800 dark:text-gray-100 transition-colors duration-300 hidden sm:block"
        onClick={handleClick}
      >
        <div className="rounded-full w-8 h-8 flex items-center justify-center hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors duration-300">
          <svg
            viewBox="0 0 1024 1024"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
          >
            <path
              d="M865.9 583.2c-16.3 0-29.6 13.2-29.7 29.7v215.1c0 18-14.6 32.6-32.5 32.6H181.8c-17.9 0-32.5-14.6-32.5-32.6V292.2c0-18 14.6-32.6 32.5-32.6h291.2c16.3 0 29.6-13.4 29.6-29.7s-13.3-29.7-29.6-29.7H177.7c-48.4 0-87.7 39.5-87.7 87.9v544.2c0 48.5 39.4 87.9 87.7 87.9h630.3c48.4 0 87.7-39.5 87.7-87.9V612.8c-0.1-16.3-13.4-29.6-29.8-29.6z"
              fill="#333"
            ></path>
            <path
              d="M930.8 338.2L727.1 133.5l-6.4-6.3-0.8 0.8c-4.5-2.5-9.6-3.9-14.9-3.9-17 0-30.8 13.8-30.8 30.8 0 5.3 1.3 10.4 3.9 14.9l-0.9 0.9 141.8 142.2-145.6 0.1c-268.6 3.9-326.8 150.6-344 378.3 0 17 13.8 30.8 30.8 30.8 13.9 0 25.6-9.2 29.5-21.9l1.4-8.2c18-215.3 60.5-321.6 251.8-342.9h144.5L683.4 510.8l-5.5 7.7c-2 4.1-3 9.1-3 13.7 0 17 13.8 30.8 30.8 30.8 4.8 0 10.2-1.2 14.4-3.4l209.9-199.9c1.9-1.3 4.1-4.5 4.1-7 0-2.9-1.4-4.7-3.3-5.9z"
              fill="#333"
            ></path>
          </svg>
        </div>
      </button>

      {/* Hover 小弹窗 */}
      {showQrCode && (
        <div>
          <div className="absolute top-full -right-6 mt-2 w-48 bg-white rounded-xl shadow-lg overflow-hidden z-20 animate-fade-in">
            <div
              className="absolute inset-0"
              style={{ background: 'linear-gradient(to bottom, #fff, #f5f9ff)' }}
            ></div>
            <div className="relative p-3 z-10">
              <img
                src={shareQrcodeImg}
                alt="分享二维码"
                className="w-full h-auto rounded-md"
              />
              <p
                className="text-base text-center mt-0 text-gray-700 dark:text-gray-300"
                style={{ fontFamily: 'Sans' }}
              >
                微信扫码分享
              </p>
            </div>
          </div>
          <div
            className="absolute top-9 right-[8px] w-4 h-4 bg-white transform rotate-45 z-10"
            style={{ background: '#fff' }}
          ></div>
        </div>
      )}

      {/* 点击后全屏遮罩层 */}
      {showFullScreen && (
        <div
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] w-[100vw] h-[100vh] -left-[22px] -top-[22px]"
          onClick={handleCloseFullScreen}
        >
          <div
            className="bg-white p-6 rounded-2xl shadow-xl"
            onClick={(e) => e.stopPropagation()} // 防止点击二维码时关闭
          >
            <img
              src={shareQrcodeImg}
              alt="二维码"
              className="object-contain mx-auto"
            />
            <p className="text-center text-gray-700 mt-3 text-lg">微信扫码分享</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShareButton;
